import React from 'react';
import styled from 'styled-components'
import fond from './fond-isobar.png'

const Background = styled.div`
  background-image: url(${props => props.backgroundImage.url ? props.backgroundImage.url : fond});
  background-size: cover;
  background-repeat: no-repeat;
`;

export default Background;


// WEBPACK FOOTER //
// ./src/components/Background/index.js